import React from "react";
import Editsimg from "../../../assets/images/edits.png";
import DelImg from "../../../assets/images/dell.png";
import { Link } from "react-router-dom";
import {
  deleteAutomation,
  updateStatusForAutomationSettings,
} from "../../../redux/actions/automationSettings";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import moment from "moment";

const getMessageTitle = (req, type) => {
  if (req?.value) {
    return <p>{`${type}:- ${req.messageGroup?.title}`}</p>;
  }
  return "";
};

const AutomationListing = ({
  automations,
  setCurautomationId,
  setOpenForm,
}) => {
  const dispatch = useDispatch();
  const delAutomation = (id) => {
    dispatch(deleteAutomation(id));
  };

  const activateDeactivateAutomation = (e, id) => {
    let automationWhichWillUpdate = automations.find(
      (automation) => automation._id === id
    );
    if (automationWhichWillUpdate) {
      dispatch(updateStatusForAutomationSettings(e.target.checked ? 1 : 0, id));
    } else toast.error("Something went wrong. Please try again !");
  };

  // console.log("automations", automations)
  return (
    <div className="webhookTabContent">
      <div className="tabTableBody">
        <div className="eachTableRow heading">
          <div className="tableCells headingCells">Type</div>
          <div className="tableCells headingCells">Post title</div>
          <div className="tableCells headingCells">Group name</div>
          <div className="tableCells headingCells">Time schedule & details</div>
          <div className="tableCells headingCells">Message Group</div>
          <div className="tableCells headingCells">Delay Time</div>
          <div className="tableCells headingCells">Automation ran</div>
          <div className="tableCells headingCells">Auto ran at</div>
          <div className="tableCells headingCells">Members tagged</div>
          <div className="tableCells headingCells">Messaged</div>
          <div className="tableCells headingCells">Edit</div>
          <div className="tableCells headingCells">Delete</div>
          <div className="tableCells headingCells">Action</div>
        </div>

        {automations.map((automation, i) => {
          const groupSettingProcess =
            automation?.groupSettings?.operationProcedure;
          return (
            <div className="eachTableRow" key={i}>
              <div
                className={`tableCells contentCells ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                <div className="automationTypeBadge">
                  {automation.automationType === "welcome" && "WP"}
                  {automation.automationType === "comment" && "CP"}
                  {automation.automationType === "sendMessage" && "SM"}
                  {automation.automationType === "autoApprove" && "AA"}
                </div>
              </div>
              <div
                className={`tableCells ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {automation.postTitle}{" "}
                {!automation.validPlan && (
                  <span className="deactiveTexts">
                    UPGRADE REQUIRED TO USE THIS AUTOMATION
                  </span>
                )}
              </div>
              <div
                className={`tableCells contentCells ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {automation?.group?.groupName}
              </div>
              <div
                className={`tableCells ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                After {automation.ageOfMember} days
                {automation.scheduleType === "repeat"
                  ? " every " + automation.timeScheduleValue + " hours"
                  : automation.scheduleType === "once"
                  ? " at " + automation.timeScheduleValue
                  : ""}
              </div>
              <div
                className={`tableCells contentCells message-group-text ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {automation.automationType !== "autoApprove" &&
                  (automation?.sendMessage?.messageGroup?.title ||
                    "No message group selected")}
                {automation.automationType === "autoApprove" &&
                  !groupSettingProcess.autoDecline.messageGroup &&
                  !groupSettingProcess.sendMessageForQuestion.messageGroup &&
                  !groupSettingProcess.sendMessageIfReqAccept.messageGroup &&
                  "No message group selected"}

                {automation.automationType === "autoApprove" && (
                  <>
                    {getMessageTitle(
                      groupSettingProcess.sendMessageIfReqAccept || null,
                      "Approve"
                    )}
                    {getMessageTitle(
                      groupSettingProcess.sendMessageForQuestion || null,
                      "Specific question"
                    )}
                    {getMessageTitle(
                      groupSettingProcess.autoDecline?.messageGroup?.title ? groupSettingProcess.autoDecline : null,
                      "Auto-decline"
                    )}
                  </>
                )}
              </div>
              <div
                className={`tableCells  ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {(automation.automationType !== "autoApprove" &&
                  automation?.sendMessage?.delayTime >= 0 &&
                  automation?.sendMessage?.delayTime) ||
                  (automation.automationType === "autoApprove" &&
                    automation.groupSettings?.operationProcedure?.delayTime >=
                      0 &&
                    `${automation.groupSettings?.operationProcedure?.delayTime}`) ||
                  "N/A"}
              </div>
              <div
                className={`tableCells centerAuto ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {automation.automationRan}
              </div>
              <div
                className={`tableCells contentCells centerAuto ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {automation?.autoRanAt
                  ? moment(automation?.autoRanAt).format("MMMM Do YYYY, h:mm a")
                  : "N/A"}
              </div>
              <div
                className={`tableCells contentCells centerAuto ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {automation.noOfTagged}
              </div>
              <div
                className={`tableCells contentCells centerAuto ${
                  !automation.validPlan && "deactivated"
                }`}
              >
                {automation.messaged ? automation.messaged : "N/A"}
              </div>
              <div className="tableCells centerAuto">
                <Link
                  to=""
                  onClick={(e) => {
                    e.preventDefault();
                    setCurautomationId(automation._id);
                    setOpenForm(true);
                  }}
                >
                  <img src={Editsimg} className="actionBtnImgs" alt="" />
                </Link>
              </div>
              <div className="tableCells contentCells centerAuto">
                <Link
                  to="/#"
                  onClick={(e) => {
                    e.preventDefault();
                    delAutomation(automation._id);
                  }}
                >
                  <img src={DelImg} className="actionBtnImgs" alt="" />
                </Link>
              </div>
              <div className="tableCells contentCells">
                <label className="switchAuto">
                  <input
                    type="checkbox"
                    checked={automation.status === 1 ? true : false}
                    // disabled={!automation.validPlan ? true : false}
                    onChange={(e) => {
                      activateDeactivateAutomation(e, automation._id);
                    }}
                  />
                  <span className="sliderAuto round"></span>
                </label>
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default AutomationListing;
